import { MultipleModalConfigs } from "features/shared/types/modal";

export const PRODUCT_MODAL_CONFIG: MultipleModalConfigs = {
    ADD: {
        headingText: "New Product",
        submitBtnText: "Add",
    },
    UPDATE: {
        headingText: "Update Product",
        submitBtnText: "Update",
    },
    VIEW: {
        headingText: "View Product",
    },
};
